// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{margin:0;max-width:1280px;background-color:#f2f2f2}@media only screen and (min-width:1280px){body{margin:auto}}.app-container{box-shadow:0 -.375em .5em .125em #dadada}.screen-reader-only{position:absolute;clip:rect(1px 1px 1px 1px);white-space:nowrap;padding:0;border:0;height:1px;width:1px;overflow:hidden}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
